import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import Login from './Login';
import styles from './styles';
import { authUserRequest } from '../../redux/actions/auth';

const mapStateToProps = null;
const mapDispatchToProps = {
  authUserRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(Login));
